import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';

import { AnaliseService } from '../../../../../providers/analise-service';
import { MenuService } from '../../../../../providers/menu-service';
import { AlertService } from '../../../../../providers/alert-service';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';
import { ModulosController } from '../../../modulos-controller';

@Component({
  selector: 'page-balanco-financeiro',
  templateUrl: 'balanco-financeiro.html',
  providers: [
    AnaliseService
  ]
})
export class AnaliseHorizontalBalancoFinanceiroPage extends ModulosController {
  abaTipoBalanco: any;
  arrayBalancoFinanceiro: any;
  formatadorNumerico: any;
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "1041";

  constructor(public navParams: NavParams,
    private analiseService: AnaliseService,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.abaTipoBalanco = 'ingressos';

    this.carregarDados();
    this.setModuloId(4);
    this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
  }

  carregarDados() {
    this.analiseService.obterAnaliseHorizontalBF(this.idSecaoPagina).subscribe(data => {
      this.arrayBalancoFinanceiro = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  formatarPorcentagem(valor) {
    if (valor) 
      return valor.toString().replace('.', ',') + "%";
    else 
      return '-'
  }

  voltarParaContabilidade() {
    this.menuService.redirecionarPagina(this.analiseService.obterIdPaginaContabilidade());
  }

  salvarFlagIncluir() {

    this.loading = true;

    this.arrayBalancoFinanceiro.resultadoAnalise = this.capitalize(this.arrayBalancoFinanceiro.resultadoAnalise);
    this.analiseService.salvarAnaliseHorizontalBF(this.arrayBalancoFinanceiro).subscribe(data => {
      this.alertService.mostraAlerta("", "Salvo com sucesso.");
      this.loading = false;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      this.loading = false;
    });
  }

  submeterNoCertificado() {
    let idAnalise = "";

    this.loading = true;

    if (this.arrayBalancoFinanceiro.resultadoAnalise == undefined || !this.arrayBalancoFinanceiro.resultadoAnalise || this.arrayBalancoFinanceiro.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.arrayBalancoFinanceiro.resultadoAnalise == null) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
      this.loading = false;
    } else {
      if (this.arrayBalancoFinanceiro) {
        idAnalise = this.arrayBalancoFinanceiro.idModuloAnalise;
        this.arrayBalancoFinanceiro.resultadoAnalise = this.capitalize(this.arrayBalancoFinanceiro.resultadoAnalise);
        this.analiseService.submeterAnaliseHorizontalBF(this.arrayBalancoFinanceiro).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltarParaContabilidade();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
          this.loading = false;
        });
      }
    }
  }

  capitalize(str) {
    let retorno = "";

    if (str) {
      retorno = str.charAt(0).toUpperCase() + str.slice(1);
    }

    return retorno;
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 10;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords = text.toString().split(" ");
    let numberOfWordsToTruncate = 10;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/modulo-analise/analise-horizontal/balanco-financeiro/balanco-financeiro.ts